

// import React, { lazy, Suspense, useEffect } from 'react';
// import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import './App.css';
// import { AuthProvider, useAuth } from './components/AuthContext'; // Import AuthProvider and useAuth
// import { SessionsProvider } from './components/SessionContext';
// import { AcademicSessionProvider } from './components/AcademicSessionContext';
// import ProtectedRoute from './components/ProtectedRoute';
// import Register from './components/Register';
// import Login from './components/Login';
// import { toast, ToastContainer } from 'react-toastify';
// import Sidebar from './components/Sidebar'; // Import Sidebar here
// import SessionNavbar from './components/SessionNavbar'; // Import SessionNavbar here
// import FeeHeadDetails from './components/FeeHeadDetails';

// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
// import axios from 'axios';
// import RoleProtectedRoute from './components/RoleProtectedRoute';
// import { ROLES } from './constants/roles';
// import ScrollToTopButton from "./components/ScrollToTopButton";


// const AddCampusInformation = lazy(() => import('./components/AddCampusInformation'));
// const EmployeeDisciplineForm = lazy(() => import('./components/EmployeeDisciplineForm'));
// const StudentDisciplineForm = lazy(() => import('./components/StudentDisciplineForm'));
// const StudentProfile = lazy(() => import('./components/StudentProfile'));
// const TeacherProfile = lazy(() => import('./components/TeacherProfile'));
// const Home = lazy(() => import('./Home'));
// const Invoice = lazy(() => import('./components/Invoice'));
// const Stock = lazy(() => import('./components/Stock'));
// const BarcodeGenerator = lazy(() => import('./components/BarcodeGenerator'));
// const ScanBarcode = lazy(() => import('./components/ScanBarcode'));
// const Expense = lazy(() => import('./components/Expense'));
// const ExpenseHead = lazy(() => import('./components/ExpenseHead'));
// const SaleReport = lazy(() => import('./components/SaleReport'));
// const Category = lazy(() => import('./components/Category'));
// const Employee = lazy(() => import('./components/Employee'));
// const Attendance = lazy(() => import('./components/Attendance'));
// const EventPhotos = lazy(() => import('./components/EventPhotos'));

// const ApplyNow = lazy(() => import('./components/ApplyNow'));

// const RealTimeAttendanceDashboard = lazy(() => import('./components/RealTimeAttendanceDashboard'));

// const StudentAttendanceList = lazy(() => import('./components/StudentAttendanceList'));

// const Salary = lazy(() => import('./components/Salary'));
// const CreateSalary = lazy(() => import('./components/CreateSalary'));
// const Dashboards = lazy(() => import('./components/Dashboards'));
// const AdmissionForm = lazy(() => import('./components/AdmissionForm'));
// const AdmissionList = lazy(() => import('./components/AdmissionList'));
// const BanksDetail = lazy(() => import('./components/BanksDetail'));
// const Heads = lazy(() => import('./components/Heads'));
// const FeeGenerate = lazy(() => import('./components/FeeGenerate'));
// const SingleFeeGenerate = lazy(() => import('./components/SingleFeeGenerate'));
// const EditFeeVoucher = lazy(() => import('./components/EditFeeVoucher'));
// const FeeVouchers = lazy(() => import('./components/FeeVouchers'));
// const ViewVoucher = lazy(() => import('./components/ViewVoucher'));
// const BankNotes = lazy(() => import('./components/BankNotes'));
// const CreateClass = lazy(() => import('./components/CreateClass'));
// const CreateHouseAndClub = lazy(() => import('./components/CreateHouseAndClub'));
// const SelectCategories = lazy(() => import('./components/SelectCategories'));
// const Notification = lazy(() => import('./components/Notification'));



// const CreateSection = lazy(() => import('./components/CreateSection'));
// const CreateSubject = lazy(() => import('./components/CreateSubject'));
// const CreateFeeGroups = lazy(() => import('./components/CreateFeeGroups'));
// const FeePost = lazy(() => import('./components/FeePost'));
// const FeePostAll = lazy(() => import('./components/FeePostAll'));
// const PromoteStudent = lazy(() => import('./components/PromoteStudent'));
// const ViewLogs = lazy(() => import('./components/ViewLogs'));

// // const EventModal = lazy(() => import('./components/EventModal'));

// const Calendar = lazy(() => import('./components/Calendar'));


// // const Test = lazy(() => import('./components/Test'));

// const SalaryOfEmployee = lazy(() => import('./components/SalaryOfEmployee'));
// const SchoolSalaryList = lazy(() => import('./components/SchoolSalaryList'));

// const ViewSalarySlips = lazy(() => import('./components/ViewSalarySlips'));

// const SalaryList = lazy(() => import('./components/SalaryList'));


// const Overtime = lazy(() => import('./components/Overtime'));


// const EmployeeForm = lazy(() => import('./components/EmployeeForm'));

// const EmployeeList = lazy(() => import('./components/EmployeeList'));

// const FeeReports = lazy(() => import('./components/FeeReports'));

// const SalaryReports = lazy(() => import('./components/SalaryReports'));

// const FeeFine = lazy(() => import('./components/FeeFine'));

// const PayScaleWiseBasicSalary = lazy(() => import('./components/PayScaleWiseBasicSalary'));

// const IncrementsPayScaleWise = lazy(() => import('./components/IncrementsPayScaleWise'));


// const StudentIdCardGenerate = lazy(() => import('./components/StudentIdCardGenerate'));

// const EmployeeIdCardGenerate = lazy(() => import('./components/EmployeeIdCardGenerate'));


// const ChartsOfAccount = lazy(() => import('./components/ChartsOfAccount'));
// const ChartsOfAccountHead = lazy(() => import('./components/ChartsOfAccountHead'));

// const CreateVoucher = lazy(() => import('./components/CreateVoucher'));
// const FinanceReport = lazy(() => import('./components/FinanceReport'));


// const AssignSubjects = lazy(() => import('./components/AssignSubjects'));

// const AssignSubjectTeacher = lazy(() => import('./components/AssignSubjectTeacher'));

// const CreateTimeTable = lazy(() => import('./components/CreateTimeTable'));

// const CreateAccount = lazy(() => import('./components/CreateAccount'));


// const CreateTeacherAccount = lazy(() => import('./components/CreateTeacherAccount'));


// const StudentActivities = lazy(() => import('./components/StudentActivities'));

// // ........dont delete it.............
// // NProgress.configure({ showSpinner: false });
// // // Axios interceptors to use nprogress
// // axios.interceptors.request.use(config => {
// //   NProgress.start();
// //   return config;
// // }, error => {
// //   NProgress.done();
// //   return Promise.reject(error);
// // });

// // axios.interceptors.response.use(response => {
// //   NProgress.done();
// //   return response;
// // }, error => {
// //   NProgress.done();
// //   return Promise.reject(error);
// // });



// NProgress.configure({
//   showSpinner: false, // Hide the spinner
// });


// // Disable buttons
// function disableButtons() {
//   const buttons = document.querySelectorAll('input[type="button"], button, input[type="submit"]');
//   buttons.forEach(button => button.disabled = true);
// }

// // Enable buttons
// function enableButtons() {
//   const buttons = document.querySelectorAll('input[type="button"], button, input[type="submit"]');
//   buttons.forEach(button => button.disabled = false);
// }

// // Axios interceptors to use nprogress and disable/enable buttons
// axios.interceptors.request.use(config => {
//   NProgress.start();
//   disableButtons(); // Disable buttons when request starts
//   // toast.loading('Processing...');
//   return config;
// }, error => {
//   NProgress.done();
//   enableButtons(); // Enable buttons if there was an error
//   return Promise.reject(error);
// });

// axios.interceptors.response.use(response => {
//   NProgress.done();
//   enableButtons(); // Enable buttons after request completes
//   // toast.dismiss();
//   return response;
// }, error => {
//   NProgress.done();
//   enableButtons(); // Enable buttons if there was an error
//   return Promise.reject(error);
// });











// function App() {

//   // const node_api_base_url = process.env.REACT_APP_API_BASE_URL;
//   return (
//     <AuthProvider>
//       <ToastContainer
//        position="top-right"
//        autoClose={2000}  // Closes in 2 seconds globally
//        hideProgressBar={false} 
//        newestOnTop={false}
//        closeOnClick
//        rtl={false}
//        pauseOnFocusLoss={false}
//       //  draggable
//        pauseOnHover={false} // Prevents toast from staying longer if hovered
//        theme="light"
//       />
//       <AcademicSessionProvider>
//         <SessionsProvider>
//           <BrowserRouter>
//             <AppContent />
//               <ScrollToTopButton  />
//           </BrowserRouter>
//         </SessionsProvider>
//       </AcademicSessionProvider>
//     </AuthProvider>
//   );
// }

// function AppContent() {
//   const { user } = useAuth();
//   const location = useLocation();

//   useEffect(() => {

//     console.log(location.pathname);
//     if (location.pathname !== "/" && location.pathname != "/login") {
//       NProgress.start();
//       console.log("start");

//       const timeoutId = setTimeout(() => {
//         NProgress.done(); // Ensure NProgress finishes after route change
//         console.log("done (timeout)");
//       }, 300); // Adjust the delay as needed (500ms is a reasonable default)

//       return () => {
//         NProgress.done();
//         console.log("done");
//       };
//     }

//   }, [location.pathname]);

//   return (
//     <div>
//       {user && <Sidebar />} {/* Render Sidebar only if user is authenticated */}
    
//       {/* Render SessionNavbar only if user is authenticated */}
//       <div className="d-flex justify-content-center">
        
//         <div className={user && (user.user.user_type === "Student" || user.user.user_type === 'Teacher') ? "" : "col-md-2"}>
//           {/* <div className="col-md-2"> */}
//           <Routes>
//             <Route path="/register-sses-user" element={<Register />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/logout" element={<Navigate to="/login" />} />
//           </Routes>
//         </div>
//         <div
//           className={`${
//             user &&  (user.user.user_type === "Student" || user.user.user_type === 'Teacher') ? "col-md-12 pl-4" : "col-md-10 p-0"}  m-0 col-sm-12`}
//         >
//             {user && <SessionNavbar />}{" "}
//           <Suspense fallback={<div>Loading...</div>}>
//             <Routes>
//               {/* <Route
//     path="/"
//     element={
//       user ? (
//         <ProtectedRoute>
//           <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//             <Dashboards />
//           </RoleProtectedRoute>
//         </ProtectedRoute>
//       ) : (
//         <Navigate to="/login" replace />
//       )
//     }
//   /> */}

//               <Route
//                 path="/"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       { (user &&  user.user.user_type) === "Admin" ? (
//                         <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                           <Dashboards />
//                         </RoleProtectedRoute>
//                       ) : (user &&  user.user.user_type) === "Student" ? (
//                         <RoleProtectedRoute allowedRoles={[ROLES.STUDENT]}>
//                           <StudentProfile />
//                         </RoleProtectedRoute>
//                       ) : (user &&  user.user.user_type) === "Teacher" ? (
//                         <RoleProtectedRoute allowedRoles={[ROLES.TEACHER]}>
//                           <TeacherProfile />
//                         </RoleProtectedRoute>
//                       ) : (
//                         <Navigate to="/login" replace />
//                       )}
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/admission-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AdmissionForm />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/admission-form-edit"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AdmissionForm />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/pay-scale-wise-basic-salary"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <PayScaleWiseBasicSalary />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/attendance-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Attendance />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//               <Route
//                 path="/notification"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Notification />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                 <Route
//                 path="/event-photos-get"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EventPhotos />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/apply-now-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ApplyNow />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//               <Route
//                 path="/student-attendance-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <StudentAttendanceList />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/overtime"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Overtime />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/school-salary-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SchoolSalaryList />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/view-salary-slips"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ViewSalarySlips />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/employee-salary"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <IncrementsPayScaleWise />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/salary-of-employee"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SalaryOfEmployee />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/salary-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SalaryList />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/increments-pay-scale-wise"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <IncrementsPayScaleWise />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/employee-form/:form?"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EmployeeForm />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/employee-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EmployeeList />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/promote-students"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <PromoteStudent />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-fine"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeeFine />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//                <Route
//                 path="/real-time-attendance-dashboard"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <RealTimeAttendanceDashboard />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-class"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateClass />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/create-house-and-club"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateHouseAndClub />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-section"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateSection />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/add-campus-information"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AddCampusInformation />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/view-logs"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ViewLogs/>
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/student-accounts"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateAccount />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />



//               <Route
//                 path="/events"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Calendar />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/teacher-account"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateTeacherAccount />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//               <Route
//                 path="/create-subject"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateSubject />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/assign-subjects"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AssignSubjects />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//               <Route
//                 path="/assign-subject-teacher"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AssignSubjectTeacher />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-timetable"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateTimeTable />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-fee-group"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateFeeGroups />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/select-categories"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SelectCategories />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/admission-list"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <AdmissionList />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/student-id-card-generate"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <StudentIdCardGenerate />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/employee-id-card-generate"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EmployeeIdCardGenerate />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/item-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Home />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/bank-details-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <BanksDetail />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/heads"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Heads />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-head-details"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeeHeadDetails />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-generate"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeeGenerate />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/single-fee-generate"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SingleFeeGenerate />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/edit-fee-voucher"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EditFeeVoucher />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-vouchers"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeeVouchers />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/student-activities"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <StudentActivities />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//                <Route
//                 path="/student-discipline-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <StudentDisciplineForm />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />


//                <Route
//                 path="/employee-discipline-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <EmployeeDisciplineForm />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />



//               <Route
//                 path="/fee-post"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeePost />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-post-all"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeePostAll />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/view-vouchers"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ViewVoucher />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/bank-notes"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <BankNotes />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/fee-reports"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FeeReports />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/salary-reports"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SalaryReports />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/category-form"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Category />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/invoice"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Invoice />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/stock"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Stock />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/barcode"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <BarcodeGenerator />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/scan-barcode"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ScanBarcode />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/add-expense"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Expense />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/expense-head"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ExpenseHead />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/sale-report"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <SaleReport />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/add-employee"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Employee />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/attendance"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Attendance />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/salary"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <Salary />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-salary/:yearMonth/:id"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateSalary />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/charts-of-account"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ChartsOfAccount />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/charts-of-account-head"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <ChartsOfAccountHead />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/create-voucher"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <CreateVoucher />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               <Route
//                 path="/finance-report"
//                 element={
//                   user ? (
//                     <ProtectedRoute>
//                       <RoleProtectedRoute allowedRoles={[ROLES.ADMIN]}>
//                         <FinanceReport />
//                       </RoleProtectedRoute>
//                     </ProtectedRoute>
//                   ) : (
//                     <Navigate to="/login" replace />
//                   )
//                 }
//               />

//               {/* ......student routes.............. */}
//               {/* <Route
//                   path="/student-profile"
//                   element={
//                     user ? (
//                       <ProtectedRoute>
//                         <RoleProtectedRoute allowedRoles={[ROLES.STUDENT]}>
//                           <StudentProfile/>
//                         </RoleProtectedRoute>
//                       </ProtectedRoute>
//                     ) : (
//                       <Navigate to="/login" replace />
//                     )
//                   }
//                 /> */}
//             </Routes>
//           </Suspense>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;



import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './components/AuthContext';
import { SessionsProvider } from './components/SessionContext';
import { AcademicSessionProvider } from './components/AcademicSessionContext';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './components/Register';
import Login from './components/Login';
import { toast, ToastContainer } from 'react-toastify';
import Sidebar from './components/Sidebar';
import SessionNavbar from './components/SessionNavbar';
import FeeHeadDetails from './components/FeeHeadDetails';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import axios from 'axios';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import { ROLES } from './constants/roles';
import ScrollToTopButton from './components/ScrollToTopButton';

// ── Lazy imports ──────────────────────────────────────────
const AddCampusInformation     = lazy(() => import('./components/AddCampusInformation'));
const EmployeeDisciplineForm   = lazy(() => import('./components/EmployeeDisciplineForm'));
const StudentDisciplineForm    = lazy(() => import('./components/StudentDisciplineForm'));
const StudentProfile           = lazy(() => import('./components/StudentProfile'));
const TeacherProfile           = lazy(() => import('./components/TeacherProfile'));
const Home                     = lazy(() => import('./Home'));
const Invoice                  = lazy(() => import('./components/Invoice'));
const Stock                    = lazy(() => import('./components/Stock'));
const BarcodeGenerator         = lazy(() => import('./components/BarcodeGenerator'));
const ScanBarcode              = lazy(() => import('./components/ScanBarcode'));
const Expense                  = lazy(() => import('./components/Expense'));
const ExpenseHead              = lazy(() => import('./components/ExpenseHead'));
const SaleReport               = lazy(() => import('./components/SaleReport'));
const Category                 = lazy(() => import('./components/Category'));
const Employee                 = lazy(() => import('./components/Employee'));
const Attendance               = lazy(() => import('./components/Attendance'));
const EventPhotos              = lazy(() => import('./components/EventPhotos'));
const ApplyNowList                 = lazy(() => import('./components/ApplyNowList'));
const RealTimeAttendanceDashboard = lazy(() => import('./components/RealTimeAttendanceDashboard'));
const StudentAttendanceList    = lazy(() => import('./components/StudentAttendanceList'));
const Salary                   = lazy(() => import('./components/Salary'));
const CreateSalary             = lazy(() => import('./components/CreateSalary'));
const Dashboards               = lazy(() => import('./components/Dashboards'));
const AdmissionForm            = lazy(() => import('./components/AdmissionForm'));
const AdmissionList            = lazy(() => import('./components/AdmissionList'));
const BanksDetail              = lazy(() => import('./components/BanksDetail'));
const Heads                    = lazy(() => import('./components/Heads'));
const FeeGenerate              = lazy(() => import('./components/FeeGenerate'));
const SingleFeeGenerate        = lazy(() => import('./components/SingleFeeGenerate'));
const EditFeeVoucher           = lazy(() => import('./components/EditFeeVoucher'));
const FeeVouchers              = lazy(() => import('./components/FeeVouchers'));
const ViewVoucher              = lazy(() => import('./components/ViewVoucher'));
const BankNotes                = lazy(() => import('./components/BankNotes'));
const CreateClass              = lazy(() => import('./components/CreateClass'));
const CreateHouseAndClub       = lazy(() => import('./components/CreateHouseAndClub'));
const SelectCategories         = lazy(() => import('./components/SelectCategories'));
const Notification             = lazy(() => import('./components/Notification'));
const CreateSection            = lazy(() => import('./components/CreateSection'));
const CreateSubject            = lazy(() => import('./components/CreateSubject'));
const CreateFeeGroups          = lazy(() => import('./components/CreateFeeGroups'));
const FeePost                  = lazy(() => import('./components/FeePost'));
const FeePostAll               = lazy(() => import('./components/FeePostAll'));
const PromoteStudent           = lazy(() => import('./components/PromoteStudent'));
const ViewLogs                 = lazy(() => import('./components/ViewLogs'));
const Calendar                 = lazy(() => import('./components/Calendar'));
const SalaryOfEmployee         = lazy(() => import('./components/SalaryOfEmployee'));
const SchoolSalaryList         = lazy(() => import('./components/SchoolSalaryList'));
const ViewSalarySlips          = lazy(() => import('./components/ViewSalarySlips'));
const SalaryList               = lazy(() => import('./components/SalaryList'));
const Overtime                 = lazy(() => import('./components/Overtime'));
const EmployeeForm             = lazy(() => import('./components/EmployeeForm'));
const EmployeeList             = lazy(() => import('./components/EmployeeList'));
const FeeReports               = lazy(() => import('./components/FeeReports'));
const SalaryReports            = lazy(() => import('./components/SalaryReports'));
const FeeFine                  = lazy(() => import('./components/FeeFine'));
const PayScaleWiseBasicSalary  = lazy(() => import('./components/PayScaleWiseBasicSalary'));
const IncrementsPayScaleWise   = lazy(() => import('./components/IncrementsPayScaleWise'));
const StudentIdCardGenerate    = lazy(() => import('./components/StudentIdCardGenerate'));
const EmployeeIdCardGenerate   = lazy(() => import('./components/EmployeeIdCardGenerate'));
const ChartsOfAccount          = lazy(() => import('./components/ChartsOfAccount'));
const ChartsOfAccountHead      = lazy(() => import('./components/ChartsOfAccountHead'));
const CreateVoucher            = lazy(() => import('./components/CreateVoucher'));
const FinanceReport            = lazy(() => import('./components/FinanceReport'));
const AssignSubjects           = lazy(() => import('./components/AssignSubjects'));
const AssignSubjectTeacher     = lazy(() => import('./components/AssignSubjectTeacher'));
const CreateTimeTable          = lazy(() => import('./components/CreateTimeTable'));
const CreateAccount            = lazy(() => import('./components/CreateAccount'));
const CreateTeacherAccount     = lazy(() => import('./components/CreateTeacherAccount'));
const StudentActivities        = lazy(() => import('./components/StudentActivities'));
const AddExamMarks             = lazy(() => import('./components/AddExamMarks'));
const ExamReport               = lazy(() => import('./components/ExamReport'));
const CreateExam               = lazy(() => import('./components/CreateExam'));
const Downloads               = lazy(() => import('./components/Downloads'));
const BlogManager               = lazy(() => import('./components/BlogManager'));
const PasswordReset                = lazy(() => import('./components/PasswordReset'));
const AlumniAdminPanel                = lazy(() => import('./components/AlumniAdminPanel'));
const ClubAdminPanel                = lazy(() => import('./components/ClubAdminPanel'));

// ── NProgress + Axios ────────────────────────────────────
NProgress.configure({ showSpinner: false });

function disableButtons() {
  document.querySelectorAll('button, input[type="button"], input[type="submit"]')
    .forEach(b => (b.disabled = true));
}
function enableButtons() {
  document.querySelectorAll('button, input[type="button"], input[type="submit"]')
    .forEach(b => (b.disabled = false));
}

axios.interceptors.request.use(
  config => { NProgress.start(); disableButtons(); return config; },
  error  => { NProgress.done(); enableButtons(); return Promise.reject(error); }
);
axios.interceptors.response.use(
  response => { NProgress.done(); enableButtons(); return response; },
  error    => { NProgress.done(); enableButtons(); return Promise.reject(error); }
);

// ── Helper: Protected route wrapper ──────────────────────
const Guard = ({ roles, children }) => (
  <ProtectedRoute>
    <RoleProtectedRoute allowedRoles={roles}>
      {children}
    </RoleProtectedRoute>
  </ProtectedRoute>
);


const TeacherGuard = ({ children }) => (
  <Guard roles={[ROLES.TEACHER]}>{children}</Guard>
);

const AdminGuard = ({ children }) => (
  <Guard roles={[ROLES.ADMIN]}>{children}</Guard>
);

// ── Loading spinner ───────────────────────────────────────
function PageLoader() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', flexDirection: 'column', gap: 16,
      fontFamily: 'Nunito, sans-serif',
    }}>
      <div style={{
        width: 40, height: 40,
        border: '3px solid #dcfce7',
        borderTop: '3px solid #16a34a',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <span style={{ color: '#6b7280', fontSize: 13, fontWeight: 600 }}>Loading...</span>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ── App root ──────────────────────────────────────────────
function App() {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        theme="light"
      />
      <AcademicSessionProvider>
        <SessionsProvider>
          <BrowserRouter>
            <AppContent />
            <ScrollToTopButton />
          </BrowserRouter>
        </SessionsProvider>
      </AcademicSessionProvider>
    </AuthProvider>
  );
}

// ── Layout ────────────────────────────────────────────────
function AppContent() {
  const { user } = useAuth();
  const location = useLocation();
  const userType = user?.user?.user_type;
  const isStudentOrTeacher = userType === 'Student' || userType === 'Teacher';

  // NProgress on route change
  useEffect(() => {
    if (location.pathname !== '/' && location.pathname !== '/login') {
      NProgress.start();
      const t = setTimeout(() => NProgress.done(), 300);
      return () => { NProgress.done(); clearTimeout(t); };
    }
  }, [location.pathname]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

        :root {
          --sidebar-w: 260px;
          --navbar-h: 56px;
          --green-50: #f0fdf4;
          --green-100: #dcfce7;
          --green-500: #22c55e;
          --green-600: #16a34a;
        }

        *, *::before, *::after { box-sizing: border-box; }

        body {
          margin: 0;
          font-family: 'Nunito', sans-serif;
          background: var(--green-50);
          color: #1f2937;
        }

        /* NProgress bar color */
        #nprogress .bar { background: var(--green-600) !important; }
        #nprogress .peg  { box-shadow: 0 0 10px var(--green-600), 0 0 5px var(--green-600) !important; }

        /* ── Layout shell ── */
        .app-shell {
          display: flex;
          min-height: 100vh;
        }

        /* ── Sidebar slot ── */
        .app-sidebar-slot {
          width: 0;
          flex-shrink: 0;
          transition: width .25s cubic-bezier(.4,0,.2,1);
        }
        @media (min-width: 1024px) {
          .app-sidebar-slot:not(.hidden) {
            width: var(--sidebar-w);
          }
        }

        /* ── Main area ── */
        .app-main {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
        }

        /* ── Navbar ── */
        .app-navbar {
          position: sticky; top: 0; z-index: 100;
          height: var(--navbar-h);
          background: #fff;
          border-bottom: 1.5px solid var(--green-100);
          display: flex; align-items: center;
          padding: 0 20px;
          box-shadow: 0 1px 8px rgba(34,197,94,.06);
        }

        /* ── Page content ── */
        .app-content {
          flex: 1;
          padding: 24px 20px;
        }

        @media (max-width: 768px) {
          .app-content { padding: 16px 12px; }
        }

        /* ── Auth pages (login/register) full screen ── */
        .app-auth {
          min-height: 100vh;
          background: linear-gradient(135deg, var(--green-50) 0%, #fff 100%);
          display: flex; align-items: center; justify-content: center;
        }
      `}</style>

      {/* Auth routes (no sidebar) */}
      {!user && (
        <div className="app-auth">
          <Routes>
            <Route path="/register-sses-user" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      )}

      {/* App shell (with sidebar) */}
      {user && (
        <div className="app-shell">
          {/* Sidebar */}
          <div className={`app-sidebar-slot ${isStudentOrTeacher ? 'hidden' : ''}`}>
            <Sidebar />
          </div>

          {/* Main */}
          <div className="app-main">
            {/* Navbar */}
            {/* <header className="app-navbar">
              <SessionNavbar />
            </header> */}

            {/* Page */}
            <main className="app-content">
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  {/* Root redirect by role */}
                  <Route
                    path="/"
                    element={
                      userType === 'Admin' ? (
                        <AdminGuard><AdmissionForm /></AdminGuard>
                      ) : userType === 'Student' ? (
                        <Guard roles={[ROLES.STUDENT]}><StudentProfile /></Guard>
                      ) : userType === 'Teacher' ? (
                        <Guard roles={[ROLES.TEACHER]}><TeacherProfile /></Guard>
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />

                  <Route path="/logout" element={<Navigate to="/login" replace />} />

                  {/* ── Admin routes ── */}
                  <Route path="/admission-form"                  element={<AdminGuard><AdmissionForm /></AdminGuard>} />
                  <Route path="/admission-form-edit"             element={<AdminGuard><AdmissionForm /></AdminGuard>} />
                  <Route path="/admission-list"                  element={<AdminGuard><AdmissionList /></AdminGuard>} />
                  <Route path="/promote-students"                element={<AdminGuard><PromoteStudent /></AdminGuard>} />
                  <Route path="/create-class"                    element={<AdminGuard><CreateClass /></AdminGuard>} />
                  <Route path="/create-section"                  element={<AdminGuard><CreateSection /></AdminGuard>} />
                  <Route path="/create-fee-group"                element={<AdminGuard><CreateFeeGroups /></AdminGuard>} />
                  <Route path="/select-categories"               element={<AdminGuard><SelectCategories /></AdminGuard>} />
                  <Route path="/student-id-card-generate"        element={<AdminGuard><StudentIdCardGenerate /></AdminGuard>} />
                  <Route path="/student-accounts"                element={<AdminGuard><CreateAccount /></AdminGuard>} />
                  <Route path="/create-house-and-club"           element={<AdminGuard><CreateHouseAndClub /></AdminGuard>} />

                  <Route path="/student-attendance-list"         element={<AdminGuard><StudentAttendanceList /></AdminGuard>} />
                  <Route path="/attendance-list"                 element={<AdminGuard><Attendance /></AdminGuard>} />
                  <Route path="/attendance"                      element={<AdminGuard><Attendance /></AdminGuard>} />
                  <Route path="/real-time-attendance-dashboard"  element={<AdminGuard><RealTimeAttendanceDashboard /></AdminGuard>} />

                  <Route path="/bank-details-form"               element={<AdminGuard><BanksDetail /></AdminGuard>} />
                  <Route path="/bank-notes"                      element={<AdminGuard><BankNotes /></AdminGuard>} />
                  <Route path="/heads"                           element={<AdminGuard><Heads /></AdminGuard>} />
                  <Route path="/fee-head-details"                element={<AdminGuard><FeeHeadDetails /></AdminGuard>} />
                  <Route path="/fee-generate"                    element={<AdminGuard><FeeGenerate /></AdminGuard>} />
                  <Route path="/single-fee-generate"             element={<AdminGuard><SingleFeeGenerate /></AdminGuard>} />
                  <Route path="/edit-fee-voucher"                element={<AdminGuard><EditFeeVoucher /></AdminGuard>} />
                  <Route path="/fee-vouchers"                    element={<AdminGuard><FeeVouchers /></AdminGuard>} />
                  <Route path="/fee-post"                        element={<AdminGuard><FeePost /></AdminGuard>} />
                  <Route path="/fee-post-all"                    element={<AdminGuard><FeePostAll /></AdminGuard>} />
                  <Route path="/fee-fine"                        element={<AdminGuard><FeeFine /></AdminGuard>} />
                  <Route path="/fee-reports"                     element={<AdminGuard><FeeReports /></AdminGuard>} />
                  <Route path="/view-vouchers"                   element={<AdminGuard><ViewVoucher /></AdminGuard>} />

                  <Route path="/alumni"                          element={<AdminGuard><AlumniAdminPanel /></AdminGuard>} />
                   <Route path="/club"                          element={<AdminGuard><ClubAdminPanel /></AdminGuard>} />

                  <Route path="/employee-form/:form?"            element={<AdminGuard><EmployeeForm /></AdminGuard>} />
                  <Route path="/employee-list"                   element={<AdminGuard><EmployeeList /></AdminGuard>} />
                  <Route path="/employee-id-card-generate"       element={<AdminGuard><EmployeeIdCardGenerate /></AdminGuard>} />
                  <Route path="/increments-pay-scale-wise"       element={<AdminGuard><IncrementsPayScaleWise /></AdminGuard>} />
                  <Route path="/employee-salary"                 element={<AdminGuard><IncrementsPayScaleWise /></AdminGuard>} />
                  <Route path="/overtime"                        element={<AdminGuard><Overtime /></AdminGuard>} />
                  <Route path="/salary-of-employee"              element={<AdminGuard><SalaryOfEmployee /></AdminGuard>} />
                  <Route path="/school-salary-list"              element={<AdminGuard><SchoolSalaryList /></AdminGuard>} />
                  <Route path="/view-salary-slips"               element={<AdminGuard><ViewSalarySlips /></AdminGuard>} />
                  <Route path="/salary-list"                     element={<AdminGuard><SalaryList /></AdminGuard>} />
                  <Route path="/salary"                          element={<AdminGuard><Salary /></AdminGuard>} />
                  <Route path="/create-salary/:yearMonth/:id"    element={<AdminGuard><CreateSalary /></AdminGuard>} />
                  <Route path="/salary-reports"                  element={<AdminGuard><SalaryReports /></AdminGuard>} />
                  <Route path="/pay-scale-wise-basic-salary"     element={<AdminGuard><PayScaleWiseBasicSalary /></AdminGuard>} />
                  <Route path="/employee-discipline-form"        element={<AdminGuard><EmployeeDisciplineForm /></AdminGuard>} />

                  <Route path="/notification"                    element={<AdminGuard><Notification /></AdminGuard>} />
                  <Route path="/event-photos-get"                element={<AdminGuard><EventPhotos /></AdminGuard>} />
                  <Route path="/apply-now-list"                  element={<AdminGuard><ApplyNowList /></AdminGuard>} />

                  <Route path="/create-subject"                  element={<AdminGuard><CreateSubject /></AdminGuard>} />
                  <Route path="/assign-subjects"                 element={<AdminGuard><AssignSubjects /></AdminGuard>} />
                  <Route path="/assign-subject-teacher"          element={<AdminGuard><AssignSubjectTeacher /></AdminGuard>} />
                  <Route path="/create-timetable"                element={<AdminGuard><CreateTimeTable /></AdminGuard>} />
                  <Route path="/student-activities"              element={<AdminGuard><StudentActivities /></AdminGuard>} />
                  <Route path="/student-discipline-form"         element={<AdminGuard><StudentDisciplineForm /></AdminGuard>} />

                  <Route path="/charts-of-account-head"          element={<AdminGuard><ChartsOfAccountHead /></AdminGuard>} />
                  <Route path="/charts-of-account"               element={<AdminGuard><ChartsOfAccount /></AdminGuard>} />
                  <Route path="/create-voucher"                  element={<AdminGuard><CreateVoucher /></AdminGuard>} />
                  <Route path="/finance-report"                  element={<AdminGuard><FinanceReport /></AdminGuard>} />

                

                  <Route path="/item-form"                       element={<AdminGuard><Home /></AdminGuard>} />
                  <Route path="/category-form"                   element={<AdminGuard><Category /></AdminGuard>} />
                  <Route path="/invoice"                         element={<AdminGuard><Invoice /></AdminGuard>} />
                  <Route path="/stock"                           element={<AdminGuard><Stock /></AdminGuard>} />
                  <Route path="/barcode"                         element={<AdminGuard><BarcodeGenerator /></AdminGuard>} />
                  <Route path="/scan-barcode"                    element={<AdminGuard><ScanBarcode /></AdminGuard>} />
                  <Route path="/add-expense"                     element={<AdminGuard><Expense /></AdminGuard>} />
                  <Route path="/expense-head"                    element={<AdminGuard><ExpenseHead /></AdminGuard>} />
                  <Route path="/sale-report"                     element={<AdminGuard><SaleReport /></AdminGuard>} />
                  <Route path="/add-employee"                    element={<AdminGuard><Employee /></AdminGuard>} />

                  <Route path="/events"                          element={<AdminGuard><Calendar /></AdminGuard>} />
                  <Route path="/teacher-account"                 element={<AdminGuard><CreateTeacherAccount /></AdminGuard>} />
                  <Route path="/add-campus-information"          element={<AdminGuard><AddCampusInformation /></AdminGuard>} />
                  <Route path="/view-logs"                       element={<AdminGuard><ViewLogs /></AdminGuard>} />

                  <Route path="/exam-report"                     element={<AdminGuard><ExamReport/></AdminGuard>} />
                  <Route path="/create-exam"                     element={<AdminGuard><CreateExam/></AdminGuard>} />
                  <Route path="/downloads"                       element={<AdminGuard><Downloads/></AdminGuard>} />
                  <Route path="/admin/blogs"                     element={<AdminGuard><BlogManager /></AdminGuard>} />
                  <Route path="/password-reset"                   element={<AdminGuard><PasswordReset /></AdminGuard>} />

                  {/* <Route path="/add-exam-marks"                  element={<TeacherGuard><AddExamMarks/></TeacherGuard>} /> */}


                  <Route path="/add-exam-marks" element={
                    <Guard roles={[ROLES.ADMIN, ROLES.TEACHER]}>
                      <AddExamMarks/>
                    </Guard>
                  } />

                  
                    

                  {/* ── Catch all ── */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </main>
          </div>
        </div>
      )}
    </>
  );
}

export default App;